import { useEffect } from 'react';

export const SITE_TITLE = 'DELEST — Ni con el viento a favor | Preventa 5 €';
export const SITE_DESCRIPTION =
  'Preventa del nuevo single de DELEST. 5 €: «Ni con el viento a favor» y la discografía digital. Grabado en Rockaway Studios con Raúl Artana. Escucha exclusiva.';

export const CREDITOS = 'Grabado en Rockaway Studios. Producido y arreglado por Raúl Artana.';
export const ENVIO_DIGITAL = 'Escucha exclusiva antes del lanzamiento.';
export const MAIL_INFO = 'info@delest-rock.com';

export const SITE_URL = 'https://crow-delest.netlify.app';
export const WEB_OFICIAL = 'https://www.delest-rock.com';
export const TIENDA_URL = 'https://tendadelest.netlify.app';
export const INSTAGRAM_URL = 'https://www.instagram.com/delestrock';
export const FACEBOOK_URL = 'https://www.facebook.com/delestrock';
export const YOUTUBE_URL = 'https://www.youtube.com/@delestrock';
export const SPOTIFY_ARTIST = 'https://open.spotify.com/artist/64JvWCPgh3pJ3Q0i1XwGLY';

export const SAME_AS = [
  WEB_OFICIAL,
  TIENDA_URL,
  INSTAGRAM_URL,
  FACEBOOK_URL,
  YOUTUBE_URL,
  SPOTIFY_ARTIST,
];

export const FAQ_ITEMS = [
  {
    q: '¿Esto es una preventa?',
    a: `Sí: la preventa de «Ni con el viento a favor» son 5 €. Incluye el single y la discografía digital completa. ${CREDITOS} ${ENVIO_DIGITAL}`,
  },
  {
    q: '¿Cómo me llega cada pack?',
    a: `El CD y el vinilo de Persistencia salen hacia tu casa al hacer el pedido. ${ENVIO_DIGITAL} La discografía digital se envía por email.`,
  },
  {
    q: '¿A qué se destina mi dinero?',
    a: `A avanzar: máster final y videoclip profesional. ${CREDITOS} La preventa de 5 € es lo que nos permite cerrar ese tramo. CD y vinilo son Persistencia, en físico, más el single y la discografía digital.`,
  },
  {
    q: '¿Puedo pagar menos de 5 €?',
    a: 'No. La preventa es fija: 5 €. El single y la discografía digital tienen un precio claro.',
  },
  {
    q: 'Tengo un negocio. ¿Cómo colaboro?',
    a: `Ligamos tu marca al single. Quien te representa es el logo: créditos del videoclip, redes, descripción de YouTube y, en Lagwagon, cartelería digital, una publicación exclusiva y dos invitaciones al concierto de presentación. En Nufan y en Lagwagon el vinilo de Persistencia va de regalo. ${ENVIO_DIGITAL} Puedes descargar el dossier PDF en esta misma página. Escríbenos a ${MAIL_INFO} o por WhatsApp al +34 627 65 52 13.`,
  },
];

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function jsonLd() {
  const pageUrl = `${SITE_URL}/`;
  const cover = `${SITE_URL}/img/single.png`;
  const bandPhoto = `${SITE_URL}/img/IMG_0136.JPEG`;

  const artist = {
    '@type': 'MusicGroup',
    '@id': `${pageUrl}#artist`,
    name: 'DELEST',
    url: WEB_OFICIAL,
    email: MAIL_INFO,
    genre: ['Punk rock', 'Melodic punk'],
    foundingLocation: {
      '@type': 'Place',
      name: 'Castellón',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Castellón',
        addressCountry: 'ES',
      },
    },
    image: bandPhoto,
    sameAs: SAME_AS,
    owns: {
      '@type': 'OnlineStore',
      name: 'Tienda DELEST',
      url: TIENDA_URL,
    },
  };

  return {
    '@context': 'https://schema.org',
    '@graph': [
      artist,
      {
        '@type': 'WebPage',
        '@id': `${pageUrl}#webpage`,
        url: pageUrl,
        name: SITE_TITLE,
        description: SITE_DESCRIPTION,
        inLanguage: 'es-ES',
        isPartOf: { '@id': `${pageUrl}#website` },
        about: { '@id': `${pageUrl}#recording` },
        primaryImageOfPage: {
          '@type': 'ImageObject',
          url: cover,
        },
      },
      {
        '@type': 'WebSite',
        '@id': `${pageUrl}#website`,
        url: pageUrl,
        name: 'DELEST — Ni con el viento a favor',
        inLanguage: 'es-ES',
        publisher: { '@id': `${pageUrl}#artist` },
      },
      {
        '@type': 'MusicRecording',
        '@id': `${pageUrl}#recording`,
        name: 'Ni con el viento a favor',
        byArtist: { '@id': `${pageUrl}#artist` },
        inLanguage: 'es',
        genre: 'Punk rock',
        image: cover,
        recordedAt: {
          '@type': 'RecordingStudio',
          name: 'Rockaway Studios',
        },
        producer: {
          '@type': 'Person',
          name: 'Raúl Artana',
        },
        offers: {
          '@type': 'Offer',
          name: 'Preventa del single + discografía digital',
          price: '5.00',
          priceCurrency: 'EUR',
          availability: 'https://schema.org/PreOrder',
          url: `${pageUrl}#comprar`,
        },
      },
      {
        '@type': 'FAQPage',
        '@id': `${pageUrl}#faq`,
        mainEntity: FAQ_ITEMS.map(({ q, a }) => ({
          '@type': 'Question',
          name: q,
          acceptedAnswer: {
            '@type': 'Answer',
            text: a,
          },
        })),
      },
    ],
  };
}

export function useCampaignSeo() {
  useEffect(() => {
    const pageUrl = `${SITE_URL}/`;
    const cover = `${SITE_URL}/img/single.png`;

    document.title = SITE_TITLE;
    upsertMeta('name', 'description', SITE_DESCRIPTION);
    upsertMeta('name', 'robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:locale', 'es_ES');
    upsertMeta('property', 'og:site_name', 'DELEST');
    upsertMeta('property', 'og:title', SITE_TITLE);
    upsertMeta('property', 'og:description', SITE_DESCRIPTION);
    upsertMeta('property', 'og:url', pageUrl);
    upsertMeta('property', 'og:image', cover);
    upsertMeta('property', 'og:image:alt', 'Portada de Ni con el viento a favor — DELEST');
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', SITE_TITLE);
    upsertMeta('name', 'twitter:description', SITE_DESCRIPTION);
    upsertMeta('name', 'twitter:image', cover);
    upsertLink('canonical', pageUrl);

    const existing = document.getElementById('delest-jsonld');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = 'delest-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd());
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);
}
